import React, { useEffect, useState } from 'react';
import AppStrings from '../../config/appstring';
import axios from 'axios';
import AcademicFeesForm from './AcademicFees';
import TransportFeesForm from './TransportFees';
import CancelForm from './Cancel';
import FeesPrint from '../Print/FeesPrint';
import StndOveAllFeesPrint from '../Print/StndOverAllPrint';

function StatementViewForm({ onClose, studentData }) {


  const [activeForm, setActiveForm] = useState(null); 
const [admissionDate, setAdmissionDate] = useState(new Date().toISOString().split('T')[0]);
  const closeModal = () => setActiveForm(null);
   const [feeDetails, setFeeDetails] = useState([]);
     const closeForm = () => setActiveForm(null);
     const [TransportDetails, setTransportDetails] = useState([]);
     const [selectedRow, setSelectedRow] = useState(null);

   const handleInputChange = (index, field, value) => {
    const updated = [...feeDetails];
    updated[index][field] = value;
    setFeeDetails(updated);
  };

  const handleCancel =  async () => {
   // setSelectedRow(null);
   // setFeeDetails([]);
   setFeeDetails([]);
  };

  const totalPaid = feeDetails.reduce((sum, fee) => sum + (parseFloat(fee.current) || 0), 0);
   
      useEffect(() => {
        handlePayClick();
      }, []);


      const handleSubmit =  async () => {
        console.log('TEST111111');
 
  
  };


    const handlePayClick = async () => {

      console.log(studentData);

   const feeType = studentData.addfees;
    const className = studentData.class;
    const type = 'N';
    const AdmissionID=studentData.id

    if (!feeType || !className) {
      alert('Missing class or fee type for this student.');
      return;
    }

    //const url = `https://school.agnisofterp.com/agni/fees/list?TYPE=${type}&CLASS=${className}&FEESTYPE=${feeType}`;
    const url = AppStrings.StudentPaymentHistory+`?studentid=${AdmissionID}`;

    try {
      const response = await axios.get(url);
      const result =  response.data.data.SCHOOLPAYMENT;
      if (Array.isArray(result)) {
        const withEditable = result.map(item => ({ ...item, current: '', discount: '' }));
        setFeeDetails(withEditable);
      } else {
     
        setFeeDetails([]);
      }
 const result1 =  response.data.data.BUSPAYMENT;
console.log(result1,'kkkkkkkkkkkkkkk');
      if (Array.isArray(result1)) {
        const withEditable = result1.map(item => ({ ...item, current: '', discount: '' }));
         //setMode('pay');
       // setSelectedRow(row);
        setTransportDetails(withEditable);
      } else {
       // alert(`No fee records found for ${row.NAME}`);
       // alert(`No fee records found for HIIIII`);
        setTransportDetails([]);
      }


    } catch (error) {
      console.error("Error fetching fee details:", error);
      //alert("Failed to fetch fee details.");
    }
  };


  const handleCancelFormClose = () => {
  setActiveForm(null);
  setSelectedRow(null);
  handlePayClick(); // refresh updated fee lists
};
 
  return (
    <div style={modalOverlayStyle}>
      <div style={{ ...modalStyle, position: 'relative' }}>
        {/* Top-right Close "X" Button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            background: 'transparent',
            //background: 'red',
            border: 'none',
            fontSize: '30px',
            fontWeight: 'bold',
            cursor: 'pointer',
            color: '#888',
          }}
          aria-label="Close"
        >
          &times;
        </button>

        <h3 style={{ textAlign: 'center' }}>Statement View</h3>

        {studentData && (
              <>
          <div style={{ marginBottom: '15px', textAlign: 'center' }}>
            <strong>Student:</strong> {studentData.name}
            <strong>Id:</strong> {studentData.id}
          </div>
        
          <h4>Academic Payments</h4>
          </>
        )}
          {feeDetails.length > 0 ? (
             <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
              <table style={{ width: '100%', marginTop: '10px',overflowY: 'auto', border: '1px solid #ccc',borderCollapse: 'collapse',   tableLayout: 'fixed' }}>
                <thead>
                  <tr>
                     <th style={headerCellStyle}>Vou No</th>
                    <th style={headerCellStyle}>Date</th>
                    <th style={headerCellStyle}>Fee Type</th>
                    <th style={headerCellStyle}>Fee Amount</th>
                    <th style={headerCellStyle}>Discount</th>
                    <th style={headerCellStyle}>Payment</th>
                   
                    <th style={headerCellStyle}></th>
                  </tr>
                </thead>
                <tbody>
                  {feeDetails.map((fee, idx) => {
    //                 const rowStyle = {
    //   backgroundColor: idx % 2 === 0 ? '#ffffff' : '#d6fffb', // white for even, light gray for odd
    // };
                    return (
                      // <tr key={idx} style={rowStyle}>
                       <tr key={idx}>
                         <td style={cellStyle}>{fee.VOUNO}</td>
                        <td style={cellStyle}>{fee.DATE}</td>
                        <td style={cellStyle}>{fee.TYPE}</td>
                         <td style={cellStyle}>{fee.AMOUNT.toFixed(2)}</td>
                         <td style={cellStyle}>{fee.DISCOUNT.toFixed(2)}</td>
                         <td style={cellStyle}>{fee.PAYMENT.toFixed(2)}</td>
                         
                           
                           <td style={{ ...cellStyle }}><button className="GridButton1" onClick={() => {
                          
  setSelectedRow(fee);    
  setActiveForm('Cancel');
}}>Delete</button>
<button className="GridButton1" style={{backgroundColor:'#92f0c4'}} onClick={() => {
                          
  setSelectedRow(fee);    
  setActiveForm('Print');
}}>Print</button>
</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              </div>
            
            ) : (
              <p>No fee data available.</p>
            )}
 {studentData && (
              <>
         <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
        {/* <button onClick={handleSubmit} style={collectButtonStyle}>
          
          Print
        </button> */}

        <button className="GridButton1" style={{ 
    ...collectButtonStyle, 
    backgroundColor: '#820344' 
  }} onClick={() => {
                          
  setActiveForm('AllPrintA');
}}>Academic Print</button> 
<button className="GridButton1" style={{ 
    ...collectButtonStyle, 
    backgroundColor: '#825E03' 
  }} onClick={() => {
                          
  setActiveForm('AllPrintT');
}}>Transport Print</button>
        </div>
        
          <h4>Transport Payments</h4>
          </>
        )}
          {TransportDetails.length > 0 ? (
              <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
              <table style={{ width: '100%', marginTop: '10px',overflowY: 'auto', border: '1px solid #ccc',borderCollapse: 'collapse',   tableLayout: 'fixed' }}>
                <thead>
                  <tr>
                     <th style={headerCellStyle}>Vou No</th>
                    <th style={headerCellStyle}>Date</th>
                    <th style={headerCellStyle}>Fee Type</th>
                    <th style={headerCellStyle}>Fee Amount</th>
                    <th style={headerCellStyle}>Discount</th>
                    <th style={headerCellStyle}>Payment</th>
                   
                    <th style={headerCellStyle}></th>
                  </tr>
                </thead>
                <tbody>
                  {TransportDetails.map((fee, idx) => {
                    const rowStyle = {
      backgroundColor: idx % 2 === 0 ? '#ffffff' : '#d6fffb', // white for even, light gray for odd
    };
                    return (
                      <tr key={idx} style={rowStyle}>
                         <td style={cellStyle}>{fee.VOUNO}</td>
                        <td style={cellStyle}>{fee.DATE}</td>
                        <td style={cellStyle}>{fee.TYPE+'-'+fee.PLACE}</td>
                         <td style={cellStyle}>{fee.AMOUNT.toFixed(2)}</td>
                         <td style={cellStyle}>{fee.DISCOUNT.toFixed(2)}</td>
                         <td style={cellStyle}>{fee.PAYMENT.toFixed(2)}</td>
                         
                           <td style={cellStyle}><button className="GridButton1" onClick={() => {
  setSelectedRow(fee);         // ✅ set selected student
  setActiveForm('Cancel');        // ✅ open form
}}>Delete</button>
<button className="GridButton1" style={{backgroundColor:'#92f0c4'}} onClick={() => {
                          
  setSelectedRow(fee);    
  setActiveForm('Print');
}}>Print</button>
</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              </div>
            
            ) : (
              <p>No fee data available.</p>
            )}

      </div>

      {activeForm && (
        <div style={modalOverlayStyle} onClick={closeModal}>
          <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
            {activeForm === 'Cancel' && (
              <>
               <CancelForm onClose={handleCancelFormClose}  studentData={{
     RefNo:selectedRow.REFNO,
     Amount:selectedRow.PAYMENT,
     Term:selectedRow.TYPE,
     Id:studentData.id,
     VouNo:selectedRow.VOUNO,
     SNo:selectedRow.SNO,
    }} />
              </>
            )}
             {activeForm === 'Print' && (
              <>
              <FeesPrint onClose={closeForm} RefNo={selectedRow.REFNO} />
              </>
            )}
             {activeForm === 'AllPrintA' && studentData &&  (
              
              <>
              
              <StndOveAllFeesPrint onClose={closeForm} RefNo={studentData.id}  PrntType="A" />
              </>
            )}
             {activeForm === 'AllPrintT' && studentData &&  (
              
              <>
              
              <StndOveAllFeesPrint onClose={closeForm} RefNo={studentData.id}  PrntType="T" />
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default StatementViewForm;

// === Styles ===

const collectButtonStyle = {
  marginLeft: 12,
  padding: '6px 12px',
  background: '#991ed3',
  color: 'white',
  border: 'none',
  borderRadius: 4,
  cursor: 'pointer',
  width:'15%',
fontSize:'15px'
};

const headerCellStyle = {
//  border: '1px solid #ddd',
  padding: '8px',
  backgroundColor: '#92e4f4',
  position: 'sticky',
  top: 0,
  zIndex: 1,
  fontSize:'10px',
  color:'#566c6f'
};
const cellStyle = {
  //border: '1px solid #ddd',
padding: '5px',
  fontSize:'12px',
  textAlign:'center'
};

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
};

const modalStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '8px',
  width: '700px',
  boxShadow: '0 2px 10px rgba(0,0,0,0)',
};

const buttonGroupStyle = {
  display: 'flex',
  gap: '10px',
  justifyContent: 'center',
  flexWrap: 'wrap',
  marginTop: '20px',
};
